import $ from 'jquery';
import barba from '@barba/core';
//import {createPopper} from '@popperjs/core';
import 'bootstrap';
import {gsap} from "gsap";
import menu from './utils/menu';
import modal from './utils/modal';
import common from './utils/common';
import transitions from './utils/transitions';
import scroll from './utils/scroll';
import createSwiper from './utils/swiper';

import landing from './pages/landing';
import activites from './pages/activites';
import accueil from "./pages/accueil";
import projets from "./pages/projets";

export const mobile = {state: false};
const _no_scroll = false;


window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};

$(document).ready(function () {


    // Initialisation de common
    common.init();

    // Initialisation de connexion
    //connexion.init();

    // Contrôle de la largeur de la fenêtre
    common.getWINDOW();
    if (common.$windowW < 768) {
        mobile.state = true;
    } else {
        mobile.state = false;
    }

    // Initialisation de menu
    menu.init();

    let namespace = $(".barba-container").data("barba-namespace");
    $(".nav > li[data-m=" + namespace + "]").addClass("_activ");


    // Initialisation du scroll
    scroll.show();

    // Initialisation du modal
    modal.init();

    scroll.update();


    document.addEventListener("click", (event) => {
        const el = event.target.closest('a.prevent-barba');
        if (!el) return;

        // cas download : laisser le navigateur gérer nativement
        if (el.hasAttribute('download')) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
        }

        // pour les autres cas, on bloque le comportement par défaut
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        // cas mailto
        if (el.href.startsWith('mailto:')) {
            window.location.href = el.href;
            return false;
        }

        // cas nouvel onglet
        if (el.target === '_blank') {
            window.open(el.href, '_blank', 'noopener');
            return false;
        }

        // cas navigation normale
        window.location.href = el.href;
        return false;
    }, true);

    // Configuration de Barba.js
    barba.init({
        prevent: ({el}) => {
            return !!(el && el.classList && el.classList.contains('prevent-barba'));
        },
        views: [
            {
                namespace: 'landing',
                afterEnter() {
                    scroll.update();
                    landing.init();
                }
            },
            {
                namespace: 'ACC',
                afterEnter() {
                    scroll.update();
                    accueil.init();
                }
            },
            {
                namespace: 'PROJ',
                afterEnter() {
                    scroll.update();
                    projets.init();
                }
            },
            {
                namespace: 'ACTIVITES',
                afterEnter() {
                    scroll.update();
                    activites.init();
                }
            }
        ],
        transitions: [
            transitions.basicTransition
        ],
        debug: true // Ajouté pour faciliter le débogage si nécessaire
    });


    // Gestion de la redimension de la fenêtre
    $(window).on("debouncedresize", function () {
        common.getWINDOW();
        if (common.$windowW <= 768 && mobile.state === false) {
            location.reload();
            mobile.state = true;
        } else if (common.$windowW > 768 && mobile.state === true) {
            location.reload();
            mobile.state = false;
        }
    });
});
